<template>
  <v-container fluid>
    <v-fade-transition>
      <v-overlay :value="isLoading" >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-fade-transition>
    <v-row>
      <v-col cols="12" md="2">
        <v-select
            :items="daysOptions"
            label="Days"
            v-model="days"
            @change="loadReposts"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-switch
            v-model="nsfw"
            label="NSFW"
            @change="loadReposts"
            hint="Filter MOST NSFW"
            persistent-hint
        ></v-switch>
      </v-col>
      <v-col cols="10"><v-spacer></v-spacer></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" md="4" v-for="post in reposts" :key="post.id">
        <v-card
            class="mx-auto"

            outlined
        >

          <v-img
              class="white--text align-end"
              height="200px"
              :src="post.url"
          >

          </v-img>
          <v-card-title class="pb-0"></v-card-title>
          <v-row align="center">
            <v-col cols="7">
              <v-card-subtitle class="pt-0 pb-0">r/{{ post.subreddit }}</v-card-subtitle>
              <v-card-text class="text--primary">
                <div>u/{{post.author}}</div>
                <div>{{post.created_at | formatTimestamp}}</div>
              </v-card-text>
            </v-col>
            <v-col cols="5"><div class="text-h4">{{post.repost_count}}</div></v-col>
          </v-row>




          <v-card-actions>
            <v-btn text color="orange" :href="`https://redd.it/${post.post_id}`" target="_blank">View Post</v-btn>
            <v-btn text color="orange" @click="openSearch(post.post_id)">Search</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Over18Diag></Over18Diag>
  </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import Over18Diag from "@/components/common/Over18Diag";
import moment from "moment";

const StatsRepo = RepositoryFactory.get('stats')
export default {
  name: "TopImageReposts",
  components: {Over18Diag},
  data: () => ({
    reposts: [],
    isLoading: true,
    nsfw: false,
    days: 30,
    daysOptions: [1,7,30,365],
    limit: 100
  }),
  methods: {
    loadReposts() {
      this.reposts = [];
      this.isLoading = true;
      StatsRepo.getTopImageReposts({'params': {limit: this.limit, nsfw: this.nsfw, days: this.days}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            this.isLoading = false;
            return;
          }
          this.reposts = res.data;
          this.isLoading = false;
        })
    },
    openSearch(postId) {
      let routeData = this.$router.resolve({name: 'Search', query: {postId: postId}});
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    this.loadReposts();
  },
  filters: {
    truncate: function (string, value) {
      if (string.length <= value) {
        return string;
      }
      return string.substring(0, value) + '...';
    },
    formatTimestamp(timestamp) {
      return moment.unix(timestamp).format('YY-MM-DD h:mm:ss a');
    },
  }
}
</script>

<style scoped>

</style>